import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const SemiDetachedIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "SemiDetachedIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M5.26076 13.9423C4.97187 13.9423 4.73682 13.7078 4.73682 13.4194V10.5122C4.73682 10.2229 4.97187 9.98828 5.26076 9.98828H9.65943C9.94832 9.98828 10.1834 10.2229 10.1834 10.5122V13.4194C10.1834 13.7078 9.94832 13.9423 9.65943 13.9423H5.26076ZM9.13549 12.8954V11.0362H7.98427V12.8954H9.13549ZM6.93592 12.8954V11.0362H5.7847V12.8954H6.93592Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M9.65966 10.0869H5.26093C5.02595 10.0869 4.83545 10.2774 4.83545 10.5124V13.4191C4.83545 13.6541 5.02595 13.8446 5.26093 13.8446H9.65966C9.89464 13.8446 10.0851 13.6541 10.0851 13.4191V10.5124C10.0851 10.2774 9.89464 10.0869 9.65966 10.0869ZM5.68641 10.9379H7.03478V12.9937H5.68641V10.9379ZM9.23419 12.9937H7.88578V10.9379H9.23419V12.9937Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.7007 13.9453C14.4118 13.9453 14.1768 13.7107 14.1768 13.4223V10.5152C14.1768 10.2268 14.4118 9.99219 14.7007 9.99219H19.0994C19.3883 9.99219 19.6238 10.2268 19.6238 10.5152V13.4223C19.6238 13.7107 19.3883 13.9453 19.0994 13.9453H14.7007ZM18.5754 12.8984V11.0391H17.4242V12.8984H18.5754ZM16.3763 12.8984V11.0391H15.2251V12.8984H16.3763Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.0996 10.0898H14.7009C14.4659 10.0898 14.2754 10.2803 14.2754 10.5153V13.422C14.2754 13.657 14.4659 13.8475 14.7009 13.8475H19.0996C19.3346 13.8475 19.5251 13.657 19.5251 13.422V10.5153C19.5251 10.2803 19.3346 10.0898 19.0996 10.0898ZM15.1264 10.9408H16.4748V12.9965H15.1264V10.9408ZM18.6741 12.9965H17.3258V10.9408H18.6741V12.9965Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.7192 7.32129H2.6416V8.3682H21.7192V7.32129Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M2.73975 7.41895H21.6203V8.2699H2.73975V7.41895Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M2.74024 22.4502C2.45135 22.4502 2.21582 22.2156 2.21582 21.9272V7.84436C2.21582 7.70785 2.2711 7.57422 2.36675 7.47616L7.17159 2.60595C7.26869 2.50693 7.40472 2.45021 7.54459 2.45021C7.68975 2.45117 7.82627 2.50981 7.92384 2.61172L10.2806 5.08912V3.6519C10.2806 3.36253 10.5156 3.12796 10.8045 3.12796C11.0934 3.12796 11.329 3.36253 11.329 3.6519V6.22928L12.186 7.09257L16.6116 2.60594C16.7106 2.505 16.8433 2.4502 16.9851 2.4502C17.1274 2.4502 17.26 2.50596 17.3595 2.6069L19.7331 5.03047V3.65189C19.7331 3.36252 19.9681 3.12795 20.257 3.12795C20.5459 3.12795 20.781 3.36252 20.781 3.65189V6.13987L21.9947 7.33868C22.0899 7.43482 22.1447 7.56844 22.1447 7.70496V21.9272C22.1447 22.2156 21.9096 22.4502 21.6207 22.4502H2.74024ZM21.0968 21.4033V20.2275H3.26417V21.4033H21.0968ZM21.0968 19.1806V7.87897L19.886 6.68401L16.9836 3.72112L12.6758 8.08854L12.7037 19.1806H14.8187V17.2137C14.8187 16.0658 15.7526 15.1324 16.9005 15.1324C18.0483 15.1324 18.9823 16.0658 18.9823 17.2137V19.1806H21.0968ZM17.9339 19.1806V17.2137C17.9339 16.6436 17.4706 16.1793 16.9005 16.1793C16.3304 16.1793 15.867 16.6436 15.867 17.2137V19.1806H17.9339ZM11.6563 19.1806V8.01452L7.53834 3.72689L3.23581 8.08855L3.26369 19.1806H5.37866V17.2137C5.37866 16.0658 6.31261 15.1324 7.45999 15.1324C8.60784 15.1324 9.5418 16.0658 9.5418 17.2137V19.1806L11.6563 19.1806ZM8.49393 19.1806V17.2137C8.49393 16.6436 8.03008 16.1793 7.46 16.1793C6.88992 16.1793 6.42655 16.6436 6.42655 17.2137V19.1806H8.49393Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.9244 7.40731L20.6824 6.13962V3.6512C20.6824 3.41622 20.4919 3.22572 20.2569 3.22572C20.022 3.22572 19.8315 3.41622 19.8315 3.6512V5.27099L17.2887 2.67558C17.2089 2.59408 17.0996 2.54805 16.9855 2.54786C16.8717 2.54786 16.7618 2.5935 16.6819 2.67454L12.1857 7.23282L11.2301 6.22873V3.65119C11.2301 3.41621 11.0396 3.22571 10.8046 3.22571C10.5696 3.22571 10.3791 3.41621 10.3791 3.65119V5.33461L7.85271 2.68002C7.7733 2.59659 7.66349 2.5489 7.54834 2.54785H7.54451C7.43071 2.54785 7.32156 2.59345 7.24161 2.67453L2.43703 7.54543C2.35851 7.62507 2.31445 7.73237 2.31445 7.84423V21.9264C2.31445 22.1614 2.50495 22.3519 2.73993 22.3519H21.6205C21.8555 22.3519 22.046 22.1614 22.046 21.9264V7.70506C22.046 7.59374 22.0023 7.48684 21.9244 7.40731ZM16.9838 3.58027L21.195 7.87874V19.2781H18.8834V17.2134C18.8834 16.1199 17.9938 15.2303 16.9003 15.2303C15.8069 15.2303 14.9172 16.1199 14.9172 17.2134V19.2781H12.6057V8.01875L16.9838 3.58027ZM18.0324 17.2134V19.2781H15.7682V17.2134C15.7682 16.5891 16.2761 16.0812 16.9004 16.0812C17.5246 16.0813 18.0324 16.5891 18.0324 17.2134ZM7.53903 3.58479L11.7547 8.01435V19.2781H9.44312V17.2134C9.44312 16.1199 8.55353 15.2303 7.46001 15.2303C6.36649 15.2303 5.47694 16.1199 5.47694 17.2134V19.2781H3.1654V8.01875L7.53903 3.58479ZM8.5922 17.2133V19.2781H6.32797V17.2133C6.32797 16.5891 6.83583 16.0812 7.46009 16.0812C8.08434 16.0813 8.5922 16.5891 8.5922 17.2133ZM21.195 21.5009H3.16541V20.1291H21.195V21.5009Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default SemiDetachedIcon;
